let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("l0ti8")).then(() => parcelRequire('1GckT'));